import React from 'react';
import DetalleCartones from "./detalle_cartones.component";
import {bindActionCreators} from "redux";
import { actualizarCarton } from "../../../actions/ventas/act_ven26";
import {connect} from "react-redux";

class TablaArticulos extends React.Component{
    constructor(props){
        super(props);
        this.state = {
        };
    }

    render(){
        const { itemsEncartonado } = this.props;
        const tdStyle = {padding: '0px 5px', margin: '0px'};
        const buttonStyle = {padding: '4px 5px', fontSize: '1.2rem', lineHeight: '1.5', borderRadius: '2px'};

        return (
            <div className='table-responsive' style={{fontSize: '75%', overflow: 'auto'}}>
                <table className='table table-condensed table-bordered'>
                    <thead>
                        <tr>
                            <th className='text-center'>No.</th>
                            <th className='col-sm-1 text-center'>Proforma</th>
                            <th className='col-sm-1 text-center'>Cód. Art.</th>
                            <th className='col-sm-6 text-center'>Descrip. Artículo</th>
                            <th className='col-sm-1 text-center'>Cant.</th>
                            <th className='col-sm-3 text-center'>Detalle Cartones</th>
                            <th className='text-center'><span role="img" aria-label="flash">⚡</span></th>
                        </tr>
                    </thead>
                    <tbody>
                        {itemsEncartonado.map((item, i) => (
                            <tr key={item.idItem} style={item.erroresDeValidacion.length>0?{backgroundColor: '#fff8dc'}:{backgroundColor: 'inherit'}}>
                                <td className='text-center' style={tdStyle}>{i + 1}</td>
                                <td className='text-center' style={tdStyle}>{item.proforma}</td>
                                <td className='text-center' style={tdStyle}>{item.articulo}</td>
                                <td style={tdStyle}>{item.nombreArtic}</td>
                                <td className='text-center' style={tdStyle}>{item.cantidadDespacho}</td>
                                <td style={tdStyle}>
                                    <div className='container-fluid'>
                                        <div className='row'>
                                            <div className='col-sm-12'>
                                                <DetalleCartones
                                                    idItem={item.idItem}
                                                    totalUnidades={item.cantidadDespacho}
                                                    detalleCartones={item.detalleCartones}
                                                    codCartonMaxLength={this.props.codCartonMaxLength}
                                                    funcionValidacionDetalleCartones={this.props.funcionValidacionDetalleCartonesPorItem}
                                                />
                                            </div>
                                        </div>
                                        {item.erroresDeValidacion.length >0 ?
                                            (<div className='row'>
                                                <div className='col-sm-12'>
                                                    {item.erroresDeValidacion.map((error,i)=>(
                                                        <p key={i} style={{color: 'red', margin: '0px'}}><small>{error}</small></p>
                                                    ))}
                                                </div>
                                            </div>)
                                            :null
                                        }
                                    </div>
                                </td>
                                <td>
                                    <button type='button' className='btn btn-default' style={buttonStyle}
                                            onClick={() => this.props.actualizarCarton(item.idItem, null, 'codCarton', this.props.ultimoCodCarton) }>
                                        <span role="img" aria-label="box">📦</span> {this.props.ultimoCodCarton}
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        )
    }
}

const mapStateToProps = (state => {
    return {    ultimoCodCarton: state.ventas.ultimoCodCarton };
});

const mapDispatchToProps = (dispatch => {
    return bindActionCreators({ actualizarCarton }, dispatch);
});

export default connect(mapStateToProps, mapDispatchToProps)(TablaArticulos);